import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { FaCross, FaSave, FaTrash } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";

const defaultvalue = {
  StoneMainName: "",
  StoneMainWeight: "0",
  StoneMainPieces: "0",
  StoneMainRate: "0",
  StoneMainAmount: "0",
  StoneMainDescription: "",
  SkuId: 0,
  CompanyId: 0,
  CounterId: 0,
  BranchId: 0,
  SKUStoneItem: [],
  ClientCode: "",
  EmployeeCode: "",
  ProductId: 0,
};
const SkuAccordian = ({
  editStatus,
  SKUStoneMain,
  style,
  allStones,
  setNewSku,
  newSku,
}) => {
  console.log(newSku);

  const { register, handleSubmit, watch, control, setValue, reset } = useForm({
    defaultValues: {
      stones: [...newSku?.SKUStoneMain, defaultvalue],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "stones", // Name of the array field
  });

  const [isOpen, setIsOpen] = useState(false);

  const formValues = watch();

  console.log(formValues);
  useEffect(() => {
    // Only reset if newSku.Diamonds has changed
    if (
      JSON.stringify(newSku?.SKUStoneMain) !==
      JSON.stringify(formValues?.stones)
    ) {
      reset({
        stones: [...newSku.SKUStoneMain],
      });
    }
  }, [newSku, reset]);

  useEffect(() => {
    // const intervalId = setInterval(() => {
    // console.log("Auto-saving data...");
    // setNewSku({
    //   ...newSku,
    //   SKUStoneMain: formValues?.stones, // Update the stones array in newSku
    // });
    setNewSku((prev) => ({
      ...prev,
      SKUStoneMain: formValues?.stones, // Update the stones array in newSku
    }));
    // }, 2000); // Save every 2 seconds

    // return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, [formValues?.stones]);


  useEffect(() => {
    // Ensure at least one form is always present when opened
    if (isOpen && fields.length === 0) {
      append(defaultvalue);
    }
  }, [isOpen]);

  const handleDropdown = () => {
    setIsOpen(!isOpen);
   
  };

  return (
    <div
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      className={style.dropdown}
    >
      <div
        // onClick={() => setIsOpen(!isOpen)}
        onClick={handleDropdown}
        // className={style.dropdownButton}
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 20px",
          background: "#627282",
        }}
      >
        <p style={{ color: "#000", margin: 0, color: "white" }}>Stone</p>
        <Icon
          // icon={isOpen ? chevronUp : chevronDown}
          icon={isOpen ? "bx:up-arrow" : "bx:down-arrow"}
          className={style.icon}
          style={{ color: "#fff", cursor: "pointer" }}
        />
      </div>

      {isOpen && (
        <div className={style.dropdownContent}>
          {fields?.map((stone, index) => (
            <StoneForm
              editStatus={editStatus}
              stone={stone}
              remove={remove}
              index={index}
              style={style}
              register={register}
              allStones={allStones}
              setValue={setValue}
              watch={watch}
              append={append}
            />
          ))}

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "10px",
              marginTop: "10px",
            }}
          >
            {/* <button
              onClick={() => append(defaultvalue)}
              type="button"
              className={style["custom-btn"]}
            >
              <Icon icon="line-md:plus" width="24" height="24" />
              Add
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default SkuAccordian;

function StoneForm({
  editStatus,
  stone,
  remove,
  index,
  style,
  register,
  allStones,
  setValue,
  watch,
  append, // Receive append function here
}) {
  const SKUStoneItems = watch(`${`stones.${index}.SKUStoneItem`}`);
  const [showDropdown, setShowDropdown] = useState(false);
  const [stoneItems, setStoneItems] = useState([]);

  useEffect(() => {
    if (editStatus) {
      console.log(SKUStoneItems);
      const result = SKUStoneItems?.map((item) => {
        return {
          ...item,
          Id: item?.StoneMasterId,
          StonePieces: item?.StonePieces,
        };
      });
      setStoneItems(result);
    }
  }, [editStatus]);

  const handleStoneItems = (item) => {
    const found = stoneItems?.filter((sItem) => sItem?.Id == item?.Id);
    if (found?.length) {
      const result = stoneItems?.filter((item) => item?.Id != found[0]?.Id);
      const result2 = SKUStoneItems?.filter((item) => item?.Id != found[0]?.Id);
      console.log(result);
      setStoneItems(result);
      setValue(`stones.${index}.SKUStoneItem`, {
        ...result2,
        StoneMasterId: result2?.Id,
      });
    } else {
      setStoneItems([...stoneItems, item]);

      setValue(`stones.${index}.SKUStoneItem`, [
        ...SKUStoneItems,
        { ...item, StoneMasterId: item?.Id },
      ]);
    }
  };
  const handleStonePiece = (e, item) => {
    const allStones = [...stoneItems];
    allStones?.find((sItem, index) => {
      if (sItem?.Id == item?.Id) {
        allStones[index].StonePieces = e.target.value;
        return true;
      }
      return false;
    });
    const SSItems = [...SKUStoneItems];
    SSItems?.find((sItem, index) => {
      if (sItem?.Id == item?.Id) {
        SSItems[index].StonePieces = e.target.value;
        return true;
      }
      return false;
    });
    console.log(allStones);
    setStoneItems(allStones);
    setValue(`stones.${index}.SKUStoneItem`, SSItems);
  };

  useEffect(() => {
    let stonename = "";
    let stonepieces = 0;
    let stoneweight = 0;
    let stoneamount = 0;
    let description = "";
    stoneItems?.forEach((stItem) => {
      stonepieces += +(stItem?.StonePieces || 0);
      stoneweight += +(stItem?.StoneWeight || 0) * +(stItem?.StonePieces || 0);
      stonename += `${stItem?.StoneName} `;
      if (stItem?.StoneRatePerPiece) {
        stoneamount +=
          +(stItem?.StoneRatePerPiece || 0) * +(stItem?.StonePieces || 0);
      } else {
        stoneamount += +(stItem?.StoneRate || 0) * +(stItem?.StoneWeight || 0);
      }

      description += `${stItem?.StonePieces} ${stItem?.StoneName}, `;
    });
    setValue(
      `stones.${index}.StoneMainName`,
      `${stonepieces} ST ${stonename} Stone`
    );
    setValue(
      `stones.${index}.StoneMainWeight`,
      "" + (+(stoneweight || 0))?.toFixed(4)
    );
    setValue(`stones.${index}.StoneMainPieces`, "" + stonepieces);
    setValue(
      `stones.${index}.StoneMainAmount`,
      "" + (+(stoneamount || 0))?.toFixed(3)
    );
    setValue(`stones.${index}.StoneMainDescription`, `${description}`);
  }, [stoneItems]);

  return (
    <div style={{marginBottom: '0px'}} className={style.adminCategoryAddCategoryInnerBox}>
      <div
        className={style["adminSkuAddSkuInnerItemsStoneBox-stone"]}
        style={{
          flexDirection: "column",
          boxShadow: "none",
        }}
      >
        <div
          style={{ boxShadow: "none" }}
          className="adminSkuAddSkuInnerItemsStoneInnerBox"
        >
          <div
            style={{ position: "relative" }}
            className="adminSkuAddSkuInnerItemsBox"
          >
            <div style={{ width: "100%" }} className={style["field-box"]}>
              <label>Select Stone 💎</label>
              <input
                type="text"
                className={style["addCategory-input"]}
                placeholder="➤"
                onFocus={() => setShowDropdown(true)}
                readOnly
              />
            </div>
            {showDropdown && (
              <div
                onMouseLeave={() => setShowDropdown(false)}
                style={{
                  position: "absolute",
                  zIndex: "2",
                  backgroundColor: "white",
                  width: "auto",
                  whiteSpace: "nowrap",
                  boxSizing: "border-box",
                  padding: "10px",
                  borderBottomRightRadius: "5px",
                  borderBottomLeftRadius: "5px",
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                }}
                className="adminSkuAddSkuInnerItemsBox"
              >
                {/* <div> */}
                {allStones?.map((stoneItem, itemIndex) => (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px",
                    }}
                    key={itemIndex}
                  >
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "10px",
                        }}
                        type="checkbox"
                        checked={
                          stoneItems?.filter(
                            (item) => item?.Id == stoneItem?.Id
                          )?.length
                        }
                        onChange={() => handleStoneItems(stoneItem)}
                        // onChange={(e) =>
                        //   handleStoneSelectionChange(
                        //     stoneItem,
                        //     e.target.checked,
                        //     index,
                        //     itemIndex
                        //   )
                        // }
                      />
                      {stoneItem.StoneName}
                    </label>
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        style={{
                          width: "40px",
                          height: "20px",
                          marginInline: "10px",
                          textAlign: "center",
                        }}
                        type="text"
                        // value={
                        //   stone?.SKUStoneItem?.find(
                        //     (si) => si.StoneMasterId == stoneItem.Id
                        //   )?.StonePieces || 0
                        // }
                        onChange={(e) => handleStonePiece(e, stoneItem)}
                        // value={stoneItems?.find((item)=>item?.Id == stoneItem?.Id)?.StonePieces || 0}
                        defaultValue={stoneItem?.StonePieces}
                        // onChange={(e) => {
                        //   const actualItemIndex =
                        //     stone.SKUStoneItem.findIndex(
                        //       (si) => si.StoneMasterId === stoneItem.Id
                        //     );
                        //   handleStonePiecesChange(e, index, actualItemIndex);
                        // }}
                      />
                      Pieces
                    </label>
                  </div>
                ))}
                {/* </div> */}
              </div>
            )}
          </div>

          <div className="adminSkuAddSkuInnerItemsBox">
            <div style={{ width: "100%" }} className={style["field-box"]}>
              <label>Stone Name</label>
              <input
                type="text"
                //   value={stone?.StoneMainName}
                {...register(`stones.${index}.StoneMainName`)}
                placeholder={`Stone Name ${index + 1}`}
                className={style["addCategory-input"]}
              />
            </div>
          </div>
          <div className="adminSkuAddSkuInnerItemsBox">
            <div style={{ width: "100%" }} className={style["field-box"]}>
              <label>Stone Weight</label>
              <input
                type="text"
                //   value={stone.StoneMainWeight}
                // value={stone.StoneWeight}
                {...register(`stones.${index}.StoneMainWeight`)}
                placeholder={`Stone Weight ${index + 1}`}
                // onChange={(e) =>
                //   updateStone(index, "StoneWeight", e.target.value)
                // }
                className={style["addCategory-input"]}
              />
            </div>
          </div>
          <div className="adminSkuAddSkuInnerItemsBox">
            <div style={{ width: "100%" }} className={style["field-box"]}>
              <label>Stone Pieces</label>
              <input
                type="text"
                //   value={stone.StoneMainPieces}
                // value={stone.StoneWeight}
                {...register(`stones.${index}.StoneMainPieces`)}
                placeholder={`Stone Pieces ${index + 1}`}
                className={style["addCategory-input"]}
                // value={stone.StonePieces}
                // placeholder={`Stone Pieces ${index + 1}`}
                // onChange={(e) =>
                //   updateStone(index, "StonePieces", e.target.value)
                // }
              />
            </div>
          </div>

          <div className="adminSkuAddSkuInnerItemsBox">
            <div style={{ width: "100%" }} className={style["field-box"]}>
              <label>Stone Amount</label>
              <input
                type="text"
                //   value={stone.StoneMainAmount}
                placeholder={`Stone Amount ${index + 1}`}
                {...register(`stones.${index}.StoneMainAmount`)}
                // readOnly
                // onChange={(e) =>
                //   updateStone(index, "StoneAmount", e.target.value)
                // }
                className={style["addCategory-input"]}
              />
            </div>
          </div>
          <div className="adminSkuAddSkuInnerItemsBox">
            <div style={{ width: "100%" }} className={style["field-box"]}>
              <label>Stone Description</label>
              <input
                type="text"
                //   value={stone.StoneMainDescription}
                // value={stone.StoneWeight}
                placeholder={`Stone Descripttion ${index + 1}`}
                {...register(`stones.${index}.StoneMainDescription`)}
                // value={stone.StoneRate}
                // placeholder={`Stone Rate ${index + 1}`}
                // onChange={(e) =>
                //   updateStone(index, "StoneRate", e.target.value)
                // }
                className={style["addCategory-input"]}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              gap: '10px',
              alignItems: 'center',
              marginTop: '26px'
            }}
            className="adminSkuAddSkuInnerItemsBox"
          >
            <FaTrash
              size={28}
              style={{ cursor: "pointer", color: "#627282" }}
              //  onClick={() => deleteStone(index)}
              onClick={() => remove(index)}
            />
            <Icon
              style={{ color: "#0077d4", cursor: "pointer" }}
              onClick={() => append(defaultvalue)}
              icon="ph:plus-fill"
              width="35"
              height="35"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
